import { render, staticRenderFns } from "./base-datatable.vue?vue&type=template&id=908f8ff8&"
import script from "./base-datatable.vue?vue&type=script&lang=js&"
export * from "./base-datatable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports